import { reactive, UnwrapRef } from "vue";

type ErrorMessages = Record<string, string>;

export class Error {
  private messages: UnwrapRef<ErrorMessages>;

  constructor() {
    this.messages = reactive({});
  }

  clear(): void {
    this.messages = reactive({});
  }

  getError(field: string): string | undefined {
    return this.messages[field];
  }

  setError(field: string, message: string): void {
    this.messages[field] = message;
  }

  setErrors(errors: ErrorMessages): void {
    this.clear();
    Object.keys(errors).forEach((field) => this.setError(field, errors[field]));
  }

  removeError(field: string): void {
    delete this.messages[field];
  }

  getMessages(): ErrorMessages {
    return this.messages;
  }

  hasErrors(): boolean {
    return Object.keys(this.messages).length > 0;
  }
}
